import { render } from "./RenewsList.vue?vue&type=template&id=36f28448"
import script from "./RenewsList.vue?vue&type=script&lang=js"
export * from "./RenewsList.vue?vue&type=script&lang=js"

import "./RenewsList.vue?vue&type=style&index=0&id=36f28448&lang=scss"

import exportComponent from "/opt/atlassian/pipelines/agent/build/node_modules/vue-loader-v16/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render]])

export default __exports__